/*
 * GENERATED RUNTIME COPY — source of truth:
 * work/capi-v2.1/shared/form-policy.v1.json
 *
 * Keep this file byte-for-byte aligned with the shared form policy through the
 * local drift test. Missing or inconsistent policy always disables Meta Lead
 * tracking; it never blocks the operational Shopify Forms submission.
 */
(() => {
  'use strict';

  const GLOBAL_KEY = 'ZinVoltMetaLeadPolicy';
  if (window[GLOBAL_KEY]) return;

  const POLICY_VERSION = 'zinvolt-meta-lead-v1';
  const DATASET_ID = '1648750049133803';
  const EVENT_NAME = 'Lead';
  const ATTRIBUTION_SCHEMA_VERSION = '1.0';
  const CONSENT_SCHEMA_VERSION = '1.1';
  const CONSENT_MAX_AGE_MS = 5 * 60 * 1000;
  const PRODUCTION_HOSTNAME = 'zinvolt.com';
  const PREVIEW_PARAMETERS = Object.freeze([
    'preview_theme_id',
    'design_theme_id',
    'pb'
  ]);

  const deepFreeze = (value) => {
    if (!value || typeof value !== 'object' || Object.isFrozen(value)) return value;
    Object.values(value).forEach(deepFreeze);
    return Object.freeze(value);
  };

  // Generated immutable copy of shared/form-policy.v1.json.
  const EVENT_SOURCE_RULES = deepFreeze({
    '1101817': {
      mode: 'any_storefront_path'
    },
    '1101824': {
      mode: 'any_storefront_path'
    },
    '1101834': {
      mode: 'exact_paths'
    },
    '1101843': {
      mode: 'disabled'
    }
  });

  const FORMS = deepFreeze({
    '1101817': {
      form_name: 'Snel energieadvies',
      metaobject_type: 'app--6171699--shopify-forms1101817',
      browser_lead: true,
      server_lead: true,
      allowed_event_source_paths: ['/']
    },
    '1101824': {
      form_name: 'Persoonlijk energieadvies',
      metaobject_type: 'app--6171699--shopify-forms1101824',
      browser_lead: true,
      server_lead: true,
      allowed_event_source_paths: ['/']
    },
    '1101834': {
      form_name: 'Salderingscheck telefonisch advies',
      metaobject_type: 'app--6171699--shopify-forms1101834',
      browser_lead: true,
      server_lead: true,
      allowed_event_source_paths: ['/pages/salderingscheck']
    },
    '1101843': {
      form_name: 'Salderingscheck offerte',
      metaobject_type: 'app--6171699--shopify-forms1101843',
      browser_lead: false,
      server_lead: false,
      allowed_event_source_paths: []
    }
  });

  const ELIGIBLE_FORM_IDS = Object.freeze(Object.keys(FORMS).filter((formId) => {
    const form = FORMS[formId];
    return form.browser_lead === true && form.server_lead === true;
  }));
  const ELIGIBLE_FORM_ID_SET = new Set(ELIGIBLE_FORM_IDS);
  const LOWERCASE_UUID_V4_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
  const EVENT_ID_PATTERN = /^zv-(1101817|1101824|1101834)-[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
  const CONSENT_KEYS = Object.freeze([
    'schema_version',
    'policy_version',
    'captured_at',
    'source',
    'analytics_storage',
    'ad_storage',
    'ad_user_data',
    'ad_personalization',
    'preferences',
    'pending_sync'
  ]);
  const DATE_TIME_PATTERN = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:\.([0-9]{1,3}))?(Z|([+-])([0-9]{2}):([0-9]{2}))$/;

  const isEligibleFormId = (value) => ELIGIBLE_FORM_ID_SET.has(String(value || ''));

  const getForm = (formId) => FORMS[String(formId || '')] || null;

  const isValidSubmissionUuid = (value) => (
    typeof value === 'string'
    && LOWERCASE_UUID_V4_PATTERN.test(value)
  );

  const createSubmissionUuid = () => {
    try {
      const uuid = window.crypto?.randomUUID?.();
      if (isValidSubmissionUuid(uuid)) return uuid;
    } catch (error) {
      // Continue only to the other Web Crypto UUID v4 implementation below.
    }

    try {
      if (!window.crypto?.getRandomValues) return '';
      const bytes = window.crypto.getRandomValues(new Uint8Array(16));
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));
      const uuid = `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
      return isValidSubmissionUuid(uuid) ? uuid : '';
    } catch (error) {
      return '';
    }
  };

  const createEventId = (formId, submissionUuid) => {
    const candidateFormId = String(formId || '');
    if (!isEligibleFormId(candidateFormId) || !isValidSubmissionUuid(submissionUuid)) return '';
    const eventId = `zv-${candidateFormId}-${submissionUuid}`;
    return EVENT_ID_PATTERN.test(eventId) ? eventId : '';
  };

  const isValidEventId = (value, formId = '') => {
    if (typeof value !== 'string' || !EVENT_ID_PATTERN.test(value)) return false;
    return !formId || value.startsWith(`zv-${String(formId)}-`);
  };

  const readRuntimeUrl = () => {
    try {
      return new URL(window.location.href);
    } catch (error) {
      return null;
    }
  };

  const runtimeBlockReason = () => {
    const runtimeUrl = readRuntimeUrl();
    if (!runtimeUrl || runtimeUrl.protocol !== 'https:' || runtimeUrl.hostname.toLowerCase() !== PRODUCTION_HOSTNAME) {
      return 'non_production_host';
    }
    if (window.Shopify?.designMode === true || document.documentElement?.classList?.contains('shopify-design-mode')) {
      return 'shopify_design_mode';
    }
    if (PREVIEW_PARAMETERS.some((parameter) => runtimeUrl.searchParams.has(parameter))) {
      return 'shopify_preview_parameter';
    }
    const themeRole = String(window.Shopify?.theme?.role || '').toLowerCase();
    if (!themeRole) return 'shopify_theme_role_unknown';
    if (themeRole !== 'main') return 'shopify_unpublished_theme';
    return '';
  };

  const isProductionRuntime = () => runtimeBlockReason() === '';

  const canonicalizeFirstPartyUrl = (value) => {
    if (
      typeof value !== 'string'
      || value.length > 2048
      || value !== value.trim()
    ) return '';
    try {
      const url = new URL(value, `https://${PRODUCTION_HOSTNAME}`);
      if (
        url.protocol !== 'https:'
        || url.hostname.toLowerCase() !== PRODUCTION_HOSTNAME
        || url.port
        || url.username
        || url.password
      ) return '';
      return `https://${PRODUCTION_HOSTNAME}${url.pathname || '/'}`;
    } catch (error) {
      return '';
    }
  };

  const canonicalizeEventSourceUrl = (formId, value) => {
    const candidateFormId = String(formId || '');
    const form = getForm(candidateFormId);
    const sourceRule = EVENT_SOURCE_RULES[candidateFormId];
    if (!form || form.browser_lead !== true || form.server_lead !== true) return '';
    if (!sourceRule || sourceRule.mode === 'disabled') return '';
    const canonicalUrl = canonicalizeFirstPartyUrl(value);
    if (!canonicalUrl) return '';
    const pathname = new URL(canonicalUrl).pathname;
    if (sourceRule.mode === 'any_storefront_path') return canonicalUrl;
    if (sourceRule.mode === 'exact_paths' && form.allowed_event_source_paths.includes(pathname)) {
      return canonicalUrl;
    }
    return '';
  };

  const parseStrictDateTime = (value) => {
    if (typeof value !== 'string' || value.length > 80) return null;
    const match = DATE_TIME_PATTERN.exec(value);
    if (!match) return null;
    const parts = match.slice(1, 7).map(Number);
    const [year, month, day, hour, minute, second] = parts;
    const millisecond = Number((match[7] || '0').padEnd(3, '0'));
    const offsetHour = match[8] === 'Z' ? 0 : Number(match[10]);
    const offsetMinute = match[8] === 'Z' ? 0 : Number(match[11]);
    if (
      month < 1 || month > 12 || day < 1 || hour > 23 || minute > 59 || second > 59
      || millisecond > 999 || offsetHour > 23 || offsetMinute > 59
    ) return null;
    const parsed = Date.parse(value);
    if (!Number.isFinite(parsed)) return null;
    const signedOffsetMinutes = match[8] === 'Z'
      ? 0
      : (match[9] === '+' ? 1 : -1) * ((offsetHour * 60) + offsetMinute);
    const local = new Date(parsed + (signedOffsetMinutes * 60 * 1000));
    if (
      local.getUTCFullYear() !== year || local.getUTCMonth() + 1 !== month
      || local.getUTCDate() !== day || local.getUTCHours() !== hour
      || local.getUTCMinutes() !== minute || local.getUTCSeconds() !== second
      || local.getUTCMilliseconds() !== millisecond
    ) return null;
    return parsed;
  };

  const isAllowedConsentState = (snapshot) => Boolean(
    snapshot
    && typeof snapshot === 'object'
    && !Array.isArray(snapshot)
    && Object.keys(snapshot).length === CONSENT_KEYS.length
    && Object.keys(snapshot).every((key) => CONSENT_KEYS.includes(key))
    && snapshot.schema_version === CONSENT_SCHEMA_VERSION
    && snapshot.policy_version === POLICY_VERSION
    && snapshot.source === 'zinvolt_cmp'
    && snapshot.analytics_storage !== undefined
    && ['granted', 'denied'].includes(snapshot.analytics_storage)
    && snapshot.ad_storage === 'granted'
    && snapshot.ad_user_data === 'granted'
    && snapshot.ad_personalization === 'granted'
    && snapshot.preferences === 'granted'
    && snapshot.pending_sync === false
  );

  const isAllowedConsentSnapshot = (snapshot, submittedAt) => {
    if (!isAllowedConsentState(snapshot)) return false;
    const capturedAtMs = parseStrictDateTime(snapshot.captured_at);
    const submittedAtMs = parseStrictDateTime(submittedAt);
    if (capturedAtMs === null || submittedAtMs === null) return false;
    const snapshotAgeMs = submittedAtMs - capturedAtMs;
    return snapshotAgeMs >= 0 && snapshotAgeMs <= CONSENT_MAX_AGE_MS;
  };

  const canDispatchBrowserLead = (tracking, currentConsentSnapshot) => {
    if (!tracking || !isProductionRuntime()) return false;
    const formId = String(tracking.formId || '');
    if (!isEligibleFormId(formId) || tracking.eventName !== EVENT_NAME) return false;
    if (!tracking.eventIdReadbackConfirmed || !tracking.consentSnapshotReadbackConfirmed) return false;
    if (!isValidEventId(tracking.eventId, formId)) return false;
    if (!isAllowedConsentSnapshot(tracking.leadContext?.consent_snapshot, tracking.submittedAt)) return false;
    if (!isAllowedConsentState(currentConsentSnapshot)) return false;
    const canonicalSourceUrl = canonicalizeEventSourceUrl(formId, tracking.eventSourceUrl);
    return Boolean(canonicalSourceUrl && canonicalSourceUrl === tracking.eventSourceUrl);
  };

  window[GLOBAL_KEY] = deepFreeze({
    policyVersion: POLICY_VERSION,
    datasetId: DATASET_ID,
    eventName: EVENT_NAME,
    attributionSchemaVersion: ATTRIBUTION_SCHEMA_VERSION,
    consentSchemaVersion: CONSENT_SCHEMA_VERSION,
    eventSourceRules: EVENT_SOURCE_RULES,
    forms: FORMS,
    eligibleFormIds: ELIGIBLE_FORM_IDS,
    getForm,
    isEligibleFormId,
    isValidSubmissionUuid,
    createSubmissionUuid,
    createEventId,
    isValidEventId,
    runtimeBlockReason,
    isProductionRuntime,
    canonicalizeFirstPartyUrl,
    canonicalizeEventSourceUrl,
    isAllowedConsentState,
    isAllowedConsentSnapshot,
    canDispatchBrowserLead
  });
})();
